import Title from "./Title";
import Content from "./Content";
import PendingImportContent from "./Content/PendingImportContent";
import ImportRequestExecutionContent from "./Content/ImportRequestExecutionContent";
import ManufacturingScheduleContent from "./Content/ManufacturingScheduleContent";
import { PageContentWrapper } from "../../shared/styled/PageContentStyle";
import TabBar, { TabBarProps } from "../../shared/components/TabBar";

const MaterialRequest = () => {
    const tabs: TabBarProps[] = [
        {
            label: "Bảng đơn lãnh vật tư",
            labelEN: "don-lanh-vat-tu",
            content: (
                <>
                    <Title />
                    <Content />
                </>
            ),
        },
        {
            label: "Bảng đề nghị nhập kho",
            labelEN: "de-nghi-nhap-kho",
            content: <PendingImportContent />,
        },
        {
            label: "Nhập kho SP",
            labelEN: "de-nghi-nhap-kho-tu-xuong",
            content: <ImportRequestExecutionContent />,
        },
        {
            label: "Bảng lịch sản xuất",
            labelEN: "lich-san-xuat",
            content: <ManufacturingScheduleContent />,
        },
        {
            label: "Bảng tồn kho xưởng",
            labelEN: "ton-kho-xuong",
            content: <div />,
        },
    ];

    return (
        <PageContentWrapper>
            <TabBar tabs={tabs} tabParamName="xuong-tab" defaultTab="don-lanh-vat-tu" />
        </PageContentWrapper>
    );
};

export default MaterialRequest;
